import { render, staticRenderFns } from "./DepartmentContextMenu.vue?vue&type=template&id=e04f1e72&scoped=true&"
import script from "./DepartmentContextMenu.vue?vue&type=script&lang=js&"
export * from "./DepartmentContextMenu.vue?vue&type=script&lang=js&"
import style0 from "./DepartmentContextMenu.vue?vue&type=style&index=0&id=e04f1e72&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e04f1e72",
  null
  
)

/* custom blocks */
import block0 from "@/locales/modules/DepartmentTranslate.json?vue&type=custom&index=0&blockType=i18n&issuerPath=%2FUsers%2Flike%2FDocuments%2FComay%2FSources%2FFe%2Flink-fe%2Fsrc%2Fviews%2Fapps%2Fdepartment%2FDepartmentContextMenu.vue"
if (typeof block0 === 'function') block0(component)

export default component.exports